import { CcModal } from "@utp/components-react";
import { Button } from "@utp/react-components-prod";
import ImgInternet from "assets/img/error-internet.svg";

interface Props {
  isOpen: boolean;
}

const ModalInternet = ({ isOpen }: Props) => {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="flex justify-center mb-xxlg" data-testid="modal-internet">
      <CcModal visible={isOpen} hideCloseButton>
        <div className="flex justify-center mb-14">
          <img src={ImgInternet} alt="clock" />
        </div>
        <div className="mb-lg">
          <h2 className="font-black text-heading-02 text-color-02 mb-lg text-center">
            No hemos encontrado conexión a internet
          </h2>
          <p className="text-center text-color-02">
            Comprueba tu conexión y vuelve a intentarlo.{" "}
          </p>
        </div>
        <div className="flex justify-center gap-lg modal-buttons">
          <Button
            text="Volver a cargar"
            color="primary"
            data-testid="btn-internet-reload"
            onClick={handleReload}
          />
        </div>
      </CcModal>
    </div>
  );
};

export default ModalInternet;
